import React, { useRef } from 'react';
import { createI13nNode } from 'react-i13n';

import usePreloadLink from 'Components/AsyncComponent/usePreloadLink';

import RoleAwareLink from './RoleAwareLink';

const VIEWPORT_OPTIONS = { threshold: 0.25 };
const VIEWPORT_CONFIG = { disconnectOnLeave: true };

const PreloadLink = (props: React.ComponentProps<typeof RoleAwareLink>) => {
  const ref = useRef<HTMLAnchorElement>(null);

  usePreloadLink({
    to: props.to,
    ref,
    viewportOptions: VIEWPORT_OPTIONS,
    viewportConfig: VIEWPORT_CONFIG,
  });

  return <RoleAwareLink ref={ref} {...props} />;
};

// preventing react-i13n's innerRef prop from propogating down to PreloadLink
const PreloadLinkOmitRef = ({
  innerRef,
  ...rest
}: React.ComponentProps<typeof PreloadLink> & { innerRef: React.RefCallback<unknown> }) => (
  <PreloadLink {...rest} />
);

const I13nPreloadLink = createI13nNode(
  PreloadLinkOmitRef,
  {},
  {
    skipUtilFunctionsByProps: true,
  }
);

export default I13nPreloadLink;
